import React, {useRef, useEffect, useCallback} from 'react';
import { Alert } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useFilterContext, useFilterDispatch } from '../contexts/FilterContextProvider';
import { loadMap, initLayerViews, initMapClick, updateItemsOnMap } from '../utils/map';
import { updateHistory } from '../utils/data';
import Loading from './Loading';
import FilterSelections from './FilterSelections';

var _filters, _view, _map, _layerViews;
var componentFirstRender = false;

function Map() {
  const mapNode = useRef();
  const loadingNode = useRef();
  const noMapResultsNode = useRef();
  const mapLoadError = useRef();
  const history = useHistory();
  const filters = useFilterContext();
  _filters = filters;
  const filterDispatch = useFilterDispatch();
  
  let postMapSelection = useCallback((mapPointParam, selectedProjects, updatedFilter) => {
    let newFilters = JSON.parse(JSON.stringify(_filters));
    newFilters.page = "";
    newFilters.mapPoint = mapPointParam;
    newFilters.map = [];
    
    filterDispatch({
      type: 'mapPoint',
      payload: mapPointParam,
      pagePayload: newFilters.page,
      projectPayload: selectedProjects,
      selectedForSnapshotPayload: _filters.selectedForSnapshot !== "" ? _filters.selectedForSnapshot : "",
      extentPayload: _filters.extent ? _filters.extent : null
    });

    if (updatedFilter !== "urlAddedMapPoint" && updatedFilter !== "") {
      updateHistory(history, newFilters);
    }    
  }, [filterDispatch, history]);

  let postMapZoom = useCallback((selectedProjects, newExtent) => {
    let newFilters = JSON.parse(JSON.stringify(_filters));
    newFilters.page = selectedProjects.length > 0 ? "" : "projects";
    let currentPage = window.location.pathname;
    
    filterDispatch({
      type: 'projectsForList',
      payload: selectedProjects,
      pagePayload: newFilters.page,
      updatedFilterPayload: "mapZoom",
      extentPayload: newExtent
    });

    if (selectedProjects.length || !newExtent) {
      noMapResultsNode.current.style.display = "none";
    }
    else {
      noMapResultsNode.current.style.display = "block";
    }

    if (currentPage === "/" || currentPage === "/tpt" || currentPage === "/tpt/") {
      updateHistory(history, newFilters);
    }
  }, [filterDispatch, history]);

  useEffect(() => {
    if (!_view && !_map && !_layerViews && !componentFirstRender) {
      componentFirstRender = true;
      loadMap({mapElt: mapNode.current, loadingElt: loadingNode.current, mapLoadErrorElt: mapLoadError.current, initDefinitionExpression: null})
      .then(mapView => {
        if (mapView) {
          _view = mapView.view;
          _map = mapView.map;
          initLayerViews(_map, _view).then(layerViews => {
            _layerViews = layerViews;
            initMapClick(_map, _view, _layerViews, postMapSelection, noMapResultsNode.current);
            updateItemsOnMap(_map, _view, _layerViews, _filters.search, _filters.location, _filters.phase, _filters.performance, _filters.year, _filters.type, _filters.admin, _filters.mapPoint, _filters.mapped, _filters.extent, _filters.updatedFilter, noMapResultsNode.current, mapLoadError.current, postMapSelection, postMapZoom);
          });
        }
      });
    }
  });
  
  useEffect(() => {
    if (_view && _map && _layerViews && filters.updatedFilter !== "page"  && filters.updatedFilter !== "fullscreen" && filters.updatedFilter !== "mapZoom") {
      updateItemsOnMap(_map, _view, _layerViews, filters.search, filters.location, filters.phase, filters.performance, filters.year, filters.type, filters.admin, filters.mapPoint, filters.mapped, filters.extent, filters.updatedFilter, noMapResultsNode.current, mapLoadError.current, postMapSelection, postMapZoom);
    }
  }, [filters.page, filters.search, filters.location, filters.phase, filters.performance, filters.year, filters.type, filters.admin, filters.mapPoint, filters.mapped, filters.extent, filters.updatedFilter, postMapSelection, postMapZoom]);

  return (
    <>
        <div className="mapLoadError" ref={mapLoadError}>
          <Alert color="danger">An error has occurred. Please try refreshing the page. If this error persists, please contact the <a href="mailto:transparency@odot.state.or.us">site administrator.</a></Alert>
        </div>
        {filters.map.includes("show") ? 
          <div className="filter-selection-wrapper filter-selection-wrapper-map">
            <FilterSelections/>
          </div>
        : null}
        <div className={filters.map.includes("full") && filters.map.includes("show") ? "projects-map-full" : "projects-map"} data-testid="map" ref={mapNode} />
        <Loading opRef={loadingNode} snapshotMap={false} />
        <div className="no-map-results" ref={noMapResultsNode}>
          No mapped data available for the selected filters.
        </div>
      </>
  );
}

export default Map;